import React from 'react'
import { motion } from 'framer-motion'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import ReliabilityWebAppSteps from '../molecules/WebAppComponents/ReliabilityWebAppSteps/ReliabilityWebAppSteps'
import Heading from '../atoms/Heading/Heading'
import WebAppIdeaProjects from '../molecules/WebAppComponents/WebAppIdeaProjects/WebAppIdeaProjects'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import { getPageData, useData } from '../../app/helper/functions'

const WebAppPage = () => {
    const { data } = useData();
    const webAppData = getPageData(data, 'webAppPage');
    
    // Animation variants
    const fadeIn = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { 
                duration: 0.8,
                ease: "easeOut"
            }
        }
    };
    
    const slideInLeft = {
        hidden: { opacity: 0, x: -50 },
        visible: { 
            opacity: 1, 
            x: 0,
            transition: { 
                duration: 0.8,
                ease: "easeOut" 
            }
        }
    };
    
    const slideInRight = {
        hidden: { opacity: 0, x: 50 },
        visible: { 
            opacity: 1, 
            x: 0,
            transition: { 
                duration: 0.8,
                ease: "easeOut" 
            }
        }
    };
    
    return (
        <div>
            <div className='bg-webapp-bg bg-center bg-cover bg-no-repeat'>
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col md:flex-row pr-[5%] md:pr-[10%] pb-8 gap-6 pt-24 md:pt-60'>
                        <motion.div 
                            className='w-full md:w-[90%] bg-[#ffffff12] rounded-r-3xl h-[200px] sm:h-[250px] md:h-[500px]'
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.3 }}
                            variants={slideInLeft}
                        >

                        </motion.div>
                        <motion.div 
                            className='text-white flex flex-col gap-2 relative text-center md:text-end justify-center items-center px-4 md:px-0'
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.3 }}
                            variants={slideInRight}
                        >
                            <div className='font-bold text-3xl sm:text-4xl md:text-6xl mb-2'>{webAppData.title}</div>
                            <div className='font-normal text-lg sm:text-xl md:text-2xl'>{webAppData.description}</div>
                        </motion.div>
                    </div>
                </div>
            </div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeIn}
                >
                    <Heading className='bg-darkGreyPrimary pt-10 md:pt-12 px-4 md:px-0 text-center'
                        text="Ready-made software may not meet your specific needs. Custom web application
                        development offers a tailored solution that enhances efficiency, security, and scalability." />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={fadeIn}
                >
                    <ReliabilityWebAppSteps webAppData={webAppData}/>
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeIn}
                >
                    <Heading className='bg-darkGreyPrimary pt-10 md:pt-12 px-4 md:px-0 text-center'
                        text="We follow a structured plan to ensure your web application is completed on time, meets
                        specifications, and is growth-ready, using agile methods for quick adjustments." />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={fadeIn}
                >
                    <WebAppIdeaProjects webAppData={webAppData}/>
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={slideInLeft}
                >
                    <ProjectDisplay />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={slideInRight}
                >
                    <AppsFaq />
                </motion.div>
                
                <motion.div 
                    className='pt-8 sm:pt-10 bg-darkGreyPrimary'
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeIn}
                >
                    <AppsRunning bgImage='bg-confident-stepdown-bg' title='Begin your web app development project now.'
                        subtitle='Ready to launch a custom web application that transforms your business?' />
                </motion.div>
                
                <DefaultFooter />
            </div>
        </div>
    )
}

export default WebAppPage
